import React from 'react';
import { styled } from 'styled-components';
import { APIBASE } from '../../config.js';
import THEME from '../../theme.js';
import X from '../Icons/X.js';
import Content from './Content.js';
const File = (props) => {
    const { file, noWrap, download } = props;
    const link = `${APIBASE}/files/${file.fileId}/${encodeURIComponent(file.fileName ?? '')}`;
    const baseProps = {
        file,
        download,
        noWrap,
    };
    return (React.createElement(FileStyled, { onClick: props.onClick, title: file.fileName || '-', draggable: true, style: props.style, onDragStart: (ev) => {
            ev.dataTransfer.setData('file-dnd', JSON.stringify(file));
        } },
        React.createElement(Content, { preview: props.preview, link: link, baseProps: baseProps }),
        props.removable && (React.createElement(X, { style: {
                margin: '1px',
                marginLeft: '10px',
            }, onClick: (e) => {
                e.preventDefault();
                if (typeof props.onRemove === 'function') {
                    props.onRemove();
                }
            } }))));
};
export default File;
const FileStyled = styled.div `
  display: inline-flex;
  max-width: 100%;
  justify-content: space-between;
  background: ${THEME.FILL};
  padding: 5px 15px;
  position: relative;
  font-size: 12px;
  border-radius: 15px;
  margin-right: 8px;
  margin-bottom: 10px;
  cursor: pointer;

  a {
    color: initial;
    text-decoration: none;
  }

  .file-icon {
    display: inline-block;
    margin: -2px 0 -2px 0;

    svg {
      margin: 2px 0px 0px 0px;
      transition: transform 0.2s;
      display: block;
    }

    height: 1.2em;
    width: 1.2em;
    overflow: hidden;
  }

  transition: transform 0.2s;

  &:hover {
    .file-icon {
      svg {
        transform: translate3d(0em, -1.2em, 0);
      }
    }
  }
`;
//# sourceMappingURL=File.js.map